import { theme } from '@branchjs/neo-components';

export const customStyles: any = {
  control: (style: any) => ({
    ...style,
    minHeight: 35,
    borderColor: theme.colors.gray[200],
    borderRadius: 8,
    color: theme.colors.text[900],
    cursor: 'default',
    outline: 'none',
    overflow: 'hidden',
    position: 'relative',
  }),
  input: (style: any) => ({ ...style, paddingLeft: 10 }),
  placeholder: (style: any) => ({ ...style, paddingLeft: 10 }),
  valueContainer: (style: any) => ({ ...style, padding: 0 }),
  singleValue: (style: any, state: any) => ({
    ...style,
    color: state.isDisabled ? theme.colors.gray[400] : state.color,
    paddingLeft: 10,
  }),
  multiValue: (style: any) => ({
    ...style,
    marginLeft: 10,
    marginRight: 5,
    color: theme.colors.gray[0],
    backgroundColor: theme.colors.gray[0],
    border: `1px solid ${theme.colors.gray[200]}`,
    borderRadius: 4,
  }),
  clearIndicator: (style: any) => ({
    ...style,
    cursor: 'pointer',
    display: 'flex',
    padding: 0,
    alignItems: 'center',
    width: 10,
    height: 10,
    ':hover': {
      color: theme.colors.error.main,
    },
  }),
  multiValueLabel: (style: any, state: any) => ({
    ...style,
    paddingRight: 6,
    color: state.isDisabled ? theme.colors.gray[400] : theme.colors.gray[900],
  }),
  multiValueRemove: (style: any) => ({
    ...style,
    paddingLeft: 0,
    cursor: 'pointer',
    color: theme.colors.gray[700],
    ':hover': {
      backgroundColor: theme.colors.gray[100],
    },
  }),
  option: (style: any, state: any) => ({
    ...style,
    color: state.isSelected ? 'inherit' : style.color,
    backgroundColor: state.isFocused ? theme.colors.gray[100] : 'transparent',
    ':active': { ...style[':active'], backgroundColor: theme.colors.gray[100] },
  }),
};
